/**
 * Created by seaasun on 2018/2/7.
 *
 *  name: just name
 *  title: display in landing page
 *  Description: display in order page
 *  demoTabs:
 *   liCharitableGiving giving: 10, 190, 200
 *   businessQpHelp: ,20,90,120,160,170,210, businessQuickPicks
 *   businessTypeHeader: ,20,90,120,160,170,180,210, businessType
 *   Demographic: 10,20,30,40,50,60,70,80,90,100,110,120,130,150,160,170,180,190,200,210 demoDemographics
 *   lifeStyleHeader: 10,30,40,50,60,70,80,90,100,110,120,130,150,160,190,200, intrestsPurchasing
 *   liAudiencePropensity: 10,190,200, audiencePropensities
 *   quickPickupHeader: 10,20,30,40,50,60,70,80,90,100,110,120,130,150,160,180,190,200 quickPicks
 *   suppressionHeader: ,10,20,30,40,50,60,70,80,90,100,110,120,130,170, suppression
 *   autoSuggestionHeader: ,10,30,40,50,60,70,80,100,110,130,150,190,200, search
 *   define Target audience: ,10,20,30,40,50,60,70,80,90,100,110,120,130,150,160,170,180,190,200,210,
 */

export default {
  10: {
    name: 'Consumer',
    title: 'Consumer',
    code: 10,
    Description: 'Consumer Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'suppression', 'search'],
    // 10 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_acxiom_radius", "geo_type_msa", "geo_type_zip_map", "geo_type_nationwide", "geo_type_Congressional_District", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'county', 'polygon', 'totalUSA', 'multiCount', 'congressionalDistrict', 'metroArea', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'], // multi === contain multiple or multiZip or both
    saveQuickPick: true,
    hasRecordsWithPhone: true,
    hasBreakDown: true,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: true,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  },
  20: {
    name: 'Business',
    title: 'Business',
    code: 20,
    Description: 'Business Lists/Leads',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'quickPicks', 'suppression'],
    // 20 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_nationwide", "geo_type_acxiom_radius", "geo_type_multigeo"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'BL',
    icon: 'bank'
  },
  30: {
    name: 'HomeData',
    title: 'New Homeowners',
    code: 30,
    Description: 'New Homeowners Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 30 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_closex", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_scf", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'closex', 'multipe', 'multi'],
    saveQuickPick: true,
    SKU: 'NHL',
    icon: 'home'
  },
  40: {
    name: 'NewMover',
    title: 'New Movers',
    code: 40,
    Description: 'New Movers',
    // 40 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_nationwide", "geo_type_acxiom_radius", "geo_type_multigeo"]
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'NM',
    icon: 'car',
    brief: 'Reach brand new homeowners and renters in any U.S. geographic area.'
  },
  50: {
    name: 'Occupant',
    title: 'Occupant/Saturation',
    code: 50,
    Description: 'Occupant/Saturation',
    // demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'search'],
    demoTabs: ['residentOccupantList'],
    // 50 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'city', 'county', 'radius'],
    geoRadius: ['address', 'zip'],
    geoBasedCarrierRoutes: true,
    saveQuickPick: true,
    noDemoSelect: true,
    isDemoOccupant: true,
    SKU: 'ROL',
    icon: 'location-arrow',
    brief: 'Reach all addresses in any U.S. geographic area.'
  },
  60: {
    name: 'NewHomeowner',
    title: 'New Homeowner',
    code: 60,
    Description: 'New Homeowner',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 60 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_closex", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_scf", "geo_type_nationwide", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'county', 'city', 'state', 'SCFCode', 'moreArea'],
    geoRadius: ['address', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'NH',
    icon: 'building',
    brief: 'Reach brand new homeowners in any U.S. geographic area'
  },
  70: {
    name: 'Equifaxc',
    title: 'Consumer Mailing Leads',
    code: 70,
    Description: 'Consumer Mailing Lists & Sales Leads – Equifax',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 70 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_scf", "geo_type_multigeo", "geo_type_zip_map"]
    geoTabs: ['zip', 'radius', 'polygon', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CML',
    icon: 'ticket'
  },
  80: {
    name: 'Experian',
    title: 'Experian',
    code: 80,
    Description: 'Consumer Lists',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 80 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CL',
    icon: 'ticket'
  },
  90: {
    name: 'Compass',
    title: 'Business',
    code: 90,
    Description: 'Business',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression'],
    // 90 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_msa", "geo_type_acxiom_radius", "geo_type_multigeo"]
    geoTabs: ['zip', 'radius', 'polygon', 'metroArea', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'B',
    icon: 'compass'
  },
  100: {
    name: 'CompassCanadianConsumer',
    title: 'Canadian Consumer',
    code: 100,
    Description: 'Canadian Consumer',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 100["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CC',
    icon: 'compass'
  },
  110: {
    name: 'InfoUSAConsumer',
    title: 'InfoUSA Consumer',
    code: 110,
    Description: 'InfoUSA Consumer Lists',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 110["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map"]
    geoTabs: ['zip', 'radius', 'polygon', 'city', 'county', 'state', 'totalUSA', 'SCFCode'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'ICL',
    icon: 'users'
  },
  120: {
    name: 'InfoUSABusiness',
    title: 'Business',
    code: 120,
    Description: 'Business Lists',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression'],
    // 120["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_multigeo", "geo_type_multiradius"]
    geoTabs: ['zip', 'radius', 'polygon', 'city', 'county', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multiZip', 'multiRaius', 'multi'],
    saveQuickPick: true,
    SKU: 'BL',
    icon: 'bank'
  },
  130: {
    name: 'Valassis',
    title: 'Valassis',
    code: 130,
    Description: 'Occupant/Saturation Lists',
    demoTabs: ['demoDemographics', 'quickPicks', 'suppression', 'search'],
    // 130["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_state", "geo_type_closex", "geo_type_scf", "geo_type_polygon", "geo_type_nationwide", "geo_type_zip_map"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'state', 'totalUSA', 'SCFCode'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'O/SL',
    icon: 'ticket'
  },
  140: {
    name: 'ResidentOccupant',
    title: 'Resident Occupant',
    code: 140,
    Description: 'Resident Occupant',
    demoTabs: ['demoDemographics'],
    // 140["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_state", "geo_type_closex"]
    geoTabs: ['zip', 'city', 'radius', 'state'],
    geoRadius: ['address', 'zip', 'closex'],
    saveQuickPick: true,
    SKU: 'RO',
    icon: 'university'
  },
  150: {
    name: 'InfoUSA_Consumer',
    title: 'InfoUSA Consumer',
    code: 150,
    Description: 'InfoUSA Consumer Lists',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'search'],
    // 150["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'county', 'state'],
    geoRadius: ['address', 'zip', 'multipe', 'multi'],
    saveQuickPick: true,
    SKU: 'ICL',
    icon: 'users',
    isInfoUSACounty: true
  },
  160: {
    name: 'InfoUSA_Business',
    title: 'Business',
    code: 160,
    Description: 'Business Lists',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks'],
    // 160["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'county', 'state'],
    geoRadius: ['address', 'zip', 'multipe'],
    saveQuickPick: true,
    SKU: 'IBL',
    icon: 'bank',
    isInfoUSACounty: true,
    brief: 'Reach specific businesses in any U.S. geographic area.'
  },
  170: {
    name: 'InfoBase_BusinessList',
    title: 'Business',
    code: 170,
    Description: 'InfoBase Business List',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'suppression'],
    // 170["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_nationwide", "geo_type_zip_map"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'county', 'state', 'totalUSA'],
    geoRadius: ['address', 'zip', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'IBL',
    icon: 'bank',
    brief: 'Pinpoint the true decision makers who need your product or service using the widest available selection criteria including business type (SIC/NAICS code), executive title, and company size.'
  },
  180: {
    name: 'InfoUSA_IDMS_Business',
    title: 'Business',
    code: 180,
    Description: 'Business List',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'businessType', 'quickPicks'],
    // 180["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['radius', 'totalUSA', 'county', 'city', 'zip', 'state', 'moreArea'],
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'BL',
    icon: 'bank'
  },
  190: {
    name: 'Mobile_Consumer_Advertising',
    title: 'Mobile Consumer Advertising',
    code: 190,
    Description: 'Mobile Consumer Advertising',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'search'],
    // 190["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_acxiom_radius", "geo_type_msa", "geo_type_multiclosex", "geo_type_nationwide", "geo_type_zip_map", "geo_type_multigeo"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'state', 'county', 'totalUSA', 'metroArea', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiClosex', 'multi'],
    saveQuickPick: true,
    SKU: 'MC',
    icon: 'mobile'
  },
  200: {
    name: 'EmailConsumers',
    title: 'Consumer',
    code: 200,
    Description: 'Consumer Email Marketing Campaign',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'search'],
    // 200["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_polygon", "geo_type_county", "geo_type_zip_map", "geo_type_state", "geo_type_msa", "geo_type_nationwide", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'multiCount', 'metroArea', 'county', 'city', 'state', 'moreArea'],
    geoRadius: ['address', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CL',
    icon: 'users'
  },
  210: {
    name: 'EmailBusinesses',
    title: 'Business',
    code: 210,
    Description: 'Business Email Marketing Campaign',
    demoTabs: ['businessQuickPicks', 'demoDemographics', 'businessType'],
    // 210["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_polygon", "geo_type_county", "geo_type_zip_map", "geo_type_state", "geo_type_msa", "geo_type_nationwide", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'multiCount', 'metroArea', 'county', 'city', 'state', 'moreArea'],
    geoRadius: ['address', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: '',
    icon: 'bank'
  },
  250: {
    name: 'InfoUsaNewConsumer',
    title: 'Consumer',
    code: 250,
    Description: 'Consumer Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'search'],
    geoTabs: ['zip', 'radius', 'county', 'polygon', 'congressionalDistrict', 'city', 'state', 'metroArea'], // scf
    geoRadius: ['address', 'zip', 'multipe', 'multiZip', 'multi'], // multi === contain multiple or multiZip or both
    saveQuickPick: true,
    hasRecordsWithPhone: false,
    hasBreakDown: false,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: false,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  },
  260: {
    name: 'InfoUSANewBusiness',
    title: 'Business',
    code: 260,
    Description: 'Business Lists/Leads',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks'],
    geoTabs: ['zip', 'radius', 'county', 'polygon', 'city', 'state', 'metroArea'], // scf
    geoRadius: ['address', 'zip', 'multipe', 'multiZip', 'multi'], // multi === contain multiple or multiZip or both
    saveQuickPick: true,
    hasRecordsWithPhone: false,
    hasBreakDown: false,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: false,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  },
  270: {
    name: 'Consumer',
    title: 'Consumer',
    code: 270,
    Description: 'Consumer Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'suppression', 'search'],
    // 10 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_acxiom_radius", "geo_type_msa", "geo_type_zip_map", "geo_type_nationwide", "geo_type_Congressional_District", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'county', 'congressionalDistrict', 'metroArea', 'city', 'state'], // scf
    geoRadius: ['address', 'zip', 'multiZip'], // multi === contain multiple or multiZip or both
    saveQuickPick: false,
    hasRecordsWithPhone: false,
    hasBreakDown: false,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: true,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  }
}



// WEBPACK FOOTER //
// ./src/config/datasource.js